import React__default from 'react';
import useAutocompleteField from './hook.js';
import FieldBase from '../FieldBase/index.js';
import MiscSearchLoader from '../../icons/generated/misc/MiscSearchLoader.js';
import FilledError from '../../icons/generated/filled/FilledError.js';
import OutlineSearchNotFound from '../../icons/generated/outline/OutlineSearchNotFound.js';
var AutoCompleteField = function AutoCompleteField(props) {
  var invalid = props.invalid,
    disabled = props.disabled,
    required = props.required,
    name = props.name,
    errorMessage = props.errorMessage,
    label = props.label,
    optional = props.optional,
    _props$autoComplete = props.autoComplete,
    autoComplete = _props$autoComplete === void 0 ? "off" : _props$autoComplete,
    tooltipConfig = props.tooltipConfig,
    placeholder = props.placeholder,
    isLoading = props.isLoading,
    _props$type = props.type,
    type = _props$type === void 0 ? "text" : _props$type,
    _props$notFoundText = props.notFoundText,
    notFoundText = _props$notFoundText === void 0 ? "Nenhum dado encontrado" : _props$notFoundText;
  var _useAutocompleteField = useAutocompleteField(props),
    onFocusHandler = _useAutocompleteField.onFocusHandler,
    onBlurHandler = _useAutocompleteField.onBlurHandler,
    displayValue = _useAutocompleteField.displayValue,
    inputChangeHandler = _useAutocompleteField.inputChangeHandler,
    shouldShowSuggestions = _useAutocompleteField.shouldShowSuggestions,
    onSelectOptionHandler = _useAutocompleteField.onSelectOptionHandler,
    inputClassName = _useAutocompleteField.inputClassName,
    displayOptions = _useAutocompleteField.displayOptions,
    inputElement = _useAutocompleteField.inputElement,
    shouldShowNotFoundIcon = _useAutocompleteField.shouldShowNotFoundIcon;
  return /* @__PURE__ */React__default.createElement("div", {
    className: inputClassName,
    onBlur: onBlurHandler
  }, /* @__PURE__ */React__default.createElement(FieldBase, {
    required: required,
    errorMessage: errorMessage,
    name: name,
    label: label,
    optional: optional,
    invalid: invalid,
    tooltipConfig: tooltipConfig
  }, /* @__PURE__ */React__default.createElement("div", {
    className: "iq-input-field__input-holder"
  }, /* @__PURE__ */React__default.createElement("input", {
    type: type,
    ref: inputElement,
    className: "iq-input-field__input",
    disabled: disabled,
    autoComplete: autoComplete,
    placeholder: placeholder,
    onFocus: onFocusHandler,
    value: displayValue,
    onChange: inputChangeHandler,
    name: name
  }), !!isLoading && /* @__PURE__ */React__default.createElement("div", {
    className: "iq-input-field__icon iq-input-field__icon--right"
  }, /* @__PURE__ */React__default.createElement("div", {
    className: "iq-input-field__invalid-icon"
  }, /* @__PURE__ */React__default.createElement(FilledError, {
    expand: true
  })), /* @__PURE__ */React__default.createElement(MiscSearchLoader, {
    expand: true
  }))), shouldShowSuggestions && /* @__PURE__ */React__default.createElement("div", {
    className: "iq-input-field__dropdown",
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    }
  }, shouldShowNotFoundIcon ? /* @__PURE__ */React__default.createElement("div", {
    className: "iq-input-field__dropdown-not-found"
  }, /* @__PURE__ */React__default.createElement("div", {
    className: "iq-input-field__dropdown-icon-holder"
  }, /* @__PURE__ */React__default.createElement(OutlineSearchNotFound, {
    expand: true
  })), /* @__PURE__ */React__default.createElement("p", null, notFoundText)) : null, /* @__PURE__ */React__default.createElement("ul", {
    className: "iq-input-field__dropdown-list"
  }, displayOptions.map(function (option, index) {
    return /* @__PURE__ */React__default.createElement("li", {
      className: "iq-input-field__dropdown-option",
      key: "input-dropdown-option-".concat(option == null ? void 0 : option.value, "-").concat(index),
      onClick: function onClick() {
        return onSelectOptionHandler(option == null ? void 0 : option.label);
      }
    }, option == null ? void 0 : option.label);
  })))));
};
export { AutoCompleteField as default };